import { HttpClient } from '@angular/common/http';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  inject,
} from '@angular/core';
// import { FactoryHttpLoader } from '@fitness-force/shared';
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'contract-term-view',
  templateUrl: './contract-term-view.component.html',
  styleUrls: ['./contract-term-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslateModule],
})
export class ContractTermViewComponent implements OnInit {
  translate = inject(TranslateService);

  columnData: Observable<any> = new BehaviorSubject(null);
  additionData: Observable<any> = new BehaviorSubject(null);
  contractTerm!: any;

  ngOnInit(): void {
    this.columnData.subscribe((cols: any) => {
      let billing_interval_type = cols?.billing_interval_type;
      let contract_term = cols?.contract_term;
      let billing_interval_value = cols?.billing_interval_value;

      if (billing_interval_type == undefined)
        billing_interval_type =
          cols?.clt_subs_billing_interval_type == 1 ? 'Week' : 'Month';
      if (contract_term == undefined)
        contract_term = cols?.clt_subs_contract_term;
      if (billing_interval_value == undefined)
        billing_interval_value = cols?.clt_subs_billing_interval_value;

      let temp: string | number | null = null;
      if (billing_interval_type == 'Week' && contract_term > 0) {
        //const temp =billing_interval_value * contract_term;
        temp = this.monthInWeeks(billing_interval_value * contract_term);
      }
      if (billing_interval_type == 'Month' && contract_term > 0) {
        temp = billing_interval_value * contract_term;
      }
      if (temp == 1) {
        this.translate.get('common.PERIOD.MONTH').subscribe((translations) => {
          this.contractTerm = '1 ' + translations;
        });
      } else {
        if (temp) {
          this.translate
            .get('common.PERIOD.MONTHS')
            .subscribe((translations) => {
              this.contractTerm = temp + ' ' + translations;
            });
        } else this.contractTerm = '';
      }
    });
  }

  weeksInMonth(month: number): number | null {
    if (!month) return null;
    return Math.round(month * 4.34524);
  }

  monthInWeeks(weeks: number): number | null {
    if (!weeks) return null;
    return Math.round(weeks * 0.230137);
  }
}
